"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var page_1 = require("./page");
var MultiPage = /** @class */ (function (_super) {
    __extends(MultiPage, _super);
    function MultiPage(config, appState, index, book, resizer, language, testFeatures) {
        var _this = _super.call(this, config, appState, index, book, resizer, language, testFeatures) || this;
        _this.size = {
            height: 500,
            width: 760
        };
        _this.layers = [{
                type: 'image',
                options: [{
                        value: "multi-page-" + language + "/" + config.glyph + ".png",
                        condition: 'true'
                    }]
            }];
        return _this;
    }
    return MultiPage;
}(page_1.default));
exports.MultiPage = MultiPage;
exports.default = MultiPage;
